import { useGate, useStore } from 'effector-react'
import { driverModel } from '~/entities/common/Driver'
import { Form } from '~/entities/common/RentalContract'
import {
  CheckIsFirstRentalContractGate,
  $checkIsFirstRentalContractIsLoading,
} from '~/entities/common/RentalContract/model'
import { usePermissions } from '~/entities/common/viewer'
import { $defaultValues, createFx, formSubmitted, requestFileFx } from './model'

export const CreateRentalContract = () => {
  useGate(CheckIsFirstRentalContractGate)

  const isSubmitting = useStore(createFx.pending)
  const isRequestFilePending = useStore(requestFileFx.pending)
  const defaultValues = useStore($defaultValues)
  const { canRentalContractsUpdatePrice, canRentalContractsSetType } =
    usePermissions()
  const checkIsFirstRentalContractIsLoading = useStore(
    $checkIsFirstRentalContractIsLoading,
  )
  const driverLoading = useStore(driverModel.requestDriverFx.pending)

  return (
    <Form
      isLoading={checkIsFirstRentalContractIsLoading || driverLoading}
      isSubmitting={isSubmitting || isRequestFilePending}
      isCreating
      onSuccess={formSubmitted}
      defaultValues={defaultValues}
      isBookedUntilVisible
      canFirstDayIsFreeEdit
      canSomeFieldEdit
      canRentalServicesEdit
      canUpdateRentPrice={canRentalContractsUpdatePrice}
      canSetContractType={canRentalContractsSetType}
      canCalculateRentPerDay
    />
  )
}
